/**
 * useWasteLayers Hook
 *
 * @version 1.0
 * @created 2026-03-26
 * @module core/modules/waste/hooks
 *
 * @description
 * Hook para gestionar capas REALES del módulo Waste.
 * Carga contenedores, depósitos y rutas desde la API del proyecto activo.
 *
 * FASE B: Corrección de visibilidad - Inicializa capas con datos reales.
 */

import { useWasteMapLayers } from './useWasteMapLayers';
import { useProject } from '../../../projects';
import { useModuleStore } from '../../../module-store';

/**
 * Hook para gestionar capas del módulo Waste
 *
 * @remarks
 * Carga datos REALES de contenedores, depósitos y rutas cuando:
 * - El proyecto está activo
 * - El módulo waste está activo
 */
export function useWasteLayers(): void {
  const { projectId } = useProject();
  const { activeModule } = useModuleStore();

  // Determinar si mostrar capas waste
  const visible = Boolean(projectId && activeModule === 'waste');

  // Cargar capas reales
  useWasteMapLayers({
    projectId: projectId || '',
    visible,
  });
}
